<template>
    <div class="otp-dialog">
      <div class="otp-dialog-overlay"></div>
      <div class="otp-dialog-content">
        <!-- <h2>Two-Factor Authentication</h2> -->
        <p>Please enter the One-Time Password (OTP) to continue:</p>
        <div class="otp-flash">{{ otp }}</div>
        <input type="text" v-model="enteredOTP" placeholder="Enter OTP" />
        <button @click="verifyOTP">Verify</button>
        <button @click="cancel">Cancel</button>
        <div class="content"> 
          <div class="error">{{ errorMessage }}</div>
          <div class="resendOtp" @click="onResendClick" :class="this.resendDisabled() ? 'inactive' : 'active' ">{{ resendMessage }}</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {
    downloadReport, getDefaultReports
  } from '../services/campaignService'
  import { mapState } from 'vuex';
  export default {
    data() {
      return {
        showDialog: false,
        otp: '',
        enteredOTP: '',
        isGeneratingOTP: false,
        resendTimer: null,
        resendSeconds: 45,
        errorMessage: '',
      };
    },
    props: {
      reportEntityId: String,
      advancedReport: Boolean,
      defaultReportsPayload: Object,
    },
    mounted() {
      this.startResendTimer();
    },
    watch:{
      enteredOTP(){
        this.errorMessage = ''
      }
    },
    computed: {
      ...mapState(['reportData','reportEntityId']),
      resendMessage() {
        return this.resendDisabled() ? `Resend OTP in ${this.formattedTime}` : 'Resend OTP';
      },
      formattedTime() {
        const minutes = Math.floor(this.resendSeconds / 60);
        const seconds = this.resendSeconds % 60;
        return `${minutes} minutes ${seconds} seconds`;
      }
    },
    methods: {
      showFlash(otp) {
        this.showDialog = true;
        this.otp = otp;
  
        setTimeout(() => {
          this.showDialog = false;
          this.otp = '';
          this.enteredOTP = '';
        }, 3000); // Adjust the duration of the flash (in milliseconds) as needed
      },
      resendDisabled() {
        return this.resendSeconds > 0;
      },
      onResendClick(){
        this.errorMessage = ''
        if(!this.resendDisabled()){
          this.$emit('resend-otp');
          this.startResendTimer();
        }
      },
      async verifyOTP() {
        if(!this.enteredOTP){
          this.errorMessage = 'Enter a valid otp'
          setTimeout(() => {
            this.errorMessage = ''
          }, 1000)
        }else{
          if (this.defaultReportsPayload) {
            const response = await getDefaultReports(this.defaultReportsPayload, this.enteredOTP);
            if (response.ok) {
              this.$emit('cancel');
              response.json()
                .then(data => {
                    data?.signedURLs?.map( url => {
                        window.open(url);
                    })
                })
            } else{
                this.errorMessage = 'OTP verification failed'
            }
          } else {
          let reportEntityIdFromSavedReports = this.reportData?.reportEntityId //JSON.parse(localStorage.getItem('reportData'))?.reportEntityId
          let id = reportEntityIdFromSavedReports ? reportEntityIdFromSavedReports : !this.advancedReport && this.reportEntityId ? this.reportEntityId : this.reportEntityId //localStorage.getItem('reportEntityId')
          let updatedReportEntityId = this.reportEntityId //localStorage.getItem('reportEntityId')
          //  if(updatedReportEntityId && this.reportEntityId !== updatedReportEntityId){
          //   id = updatedReportEntityId
          //  }
          if(id){
            downloadReport(id, this.enteredOTP)
              .then(res=>{
                  if(res.status != 200){
                      this.errorMessage = 'OTP verification failed'
                  }else{
                      this.$emit('cancel');
                      return res.json()
                  }
              })
              .then(data=>{
                  data?.signed_urls.map(url=> {
                      window.open(url);
                  })
              })
          }}
          // this.$emit('verify-otp', this.enteredOTP);
        }
      },
      cancel() {
        this.$emit('cancel');
      },
      startResendTimer() {
        this.resendSeconds = 300;
        this.resendTimer = setInterval(() => {
          this.resendSeconds--;

          if (this.resendSeconds === 0) {
            clearInterval(this.resendTimer);
          }
        }, 1000);
      },
    },
    beforeDestroy() {
      clearInterval(this.resendTimer);
    },
  };
  </script>
  
  <style scoped>
  .otp-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .otp-dialog-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .otp-dialog-content {
    position: relative;
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1;
  }
  
  .otp-dialog-content h2 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .otp-dialog-content p {
    font-size: 16px;
    margin-bottom: 20px;
  }
  
  .otp-flash {
    font-size: 32px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }
  
  input[type="text"] {
    width: 200px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 20px;
    margin-right: 20px;
  }
  
  button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    background-color: #007bff;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    margin-right: 10px;
  }
  
  button:hover {
    background-color: #0056b3;
  }
  
  button:focus {
    outline: none;
  }

  .resendOtp{
    text-align: end;
    color: #0004B5;
    font-size: 12px;
  }

  .content{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
  }

  .error{
    color: #EB5757;
  }

  .inactive{
    opacity: 0.5;
  }

  .active{
    cursor: pointer;
  }

  
  </style>
  